import { Navigate } from 'react-router-dom';

/** Official documents page removed – redirect to Tenders. */
export default function OfficialDocuments() {
  return <Navigate to="/tenders" replace />;
}
